module.exports = __webpack_public_path__ + "static/media/idea.dc28b75b.png";